var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachinesDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 33,
    className: "st0",
    width: 28,
    height: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    className: "st1",
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    className: "st1",
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    className: "st1",
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 17,
    className: "st1",
    width: 2,
    height: 12
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 17,
    className: "st1",
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 17,
    className: "st1",
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 17,
    className: "st1",
    width: 2,
    height: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachinesDefault);
export default __webpack_public_path__ + "static/media/machines-default.fe9704ce3a28258009e0958f899ae07c.svg";
export { ForwardRef as ReactComponent };